import {
  action,
  observable
  // runInAction
} from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { DbKey, WithDbId } from '../../../../../adl-gen/common/db';
import {
  AppClient
  // Auth0SamlConnection,
  // LearningProvider
} from '../../../../../adl-gen/totalinteraction/futurefit/db';
import {
  Auth0Client,
  // Entry,
  RepositoryEntrySet
} from '../../../../../adl-gen/totalinteraction/futurefit/frontend';
import {
  makeCreateAuth0ClientReq,
  makeUpdateAuth0ClientReq,
  UpdateAuth0ClientReq
  // RepositoryPutReq
} from '../../../../../adl-gen/totalinteraction/futurefit/requests';
import { AppClientData, AppClientStore } from '../../../../stores';
import { FormMode, SelectMode, toastOptions } from '../../../common/form';
// import { errorHandler, okHandler } from "../../../common/editor";
import { AdminModal } from '../../admin-modal/admin-modal';
// import {
//   // ClientDeleter,
//   ClientEditor
// } from "../../editors/client-editor";

// tslint:disable-next-line: no-import-side-effect ordered-imports
import '../../../widgets/toast/toastify.css';
import { AppClientEditor } from '../../editors/appclient-editor/appclient-editor';

interface AppClientFormProps {
  client?: WithDbId<AppClient>;
  // toDelete?: WithDbId<AppClient>[];
  clientData: AppClientData;
  store: AppClientStore;
  repository: RepositoryEntrySet;
  // onLoadClientRepository?(repos: RepositoryEntrySet, clientDomainName: string): Promise<RepositoryEntrySet>;
  // uploadRepositoryEntry(req: RepositoryPutReq): Promise<Entry>;
  // onCreate(item: AppClient): Promise<Auth0Client>;
  // onUpdate(item: WithDbId<AppClient>): Promise<Auth0Client>;
  // onDelete(a: DbKey<AppClient>[]): Promise<void>;
  /// TODO: retire this
  /** @deprecated Stop using modals */
  selectMode: SelectMode;
  mode?: FormMode;
  onCancel(): void;
  isOpen: boolean;
}

interface AppClientState {
  newClient?: Auth0Client;
  error?: Error;
  updatedClient?: Auth0Client;
  deletedClients?: DbKey<AppClient>[];
}

@observer
export class AppClientForm extends React.Component<AppClientFormProps> {
  @observable fieldState: AppClientState = {};

  /// In onCreate, we have to automatically go to Auth0 and create the
  /// 'Application' (ie. client).
  // onCreate = async (item: AppClient) => {
  //   try {
  //     const auth0Client = await this.props.onCreate(item);
  //     runInAction(() => (this.fieldState.newClient = auth0Client));
  //   } catch (e) {
  //     runInAction(() => (this.fieldState.error = e as Error));
  //   }
  // };
  /// CREATE
  ///    (1) Pass subdomain, name and logoUri to Auth0 to create Auth0 client
  ///
  ///        Auth0 validates only the client name, which has to be unique across the tenant.
  ///        For our purposes, we can't have duplicate client names or domains in skillseeker
  ///        and as this is enforced in the database it shouldn't happen.
  ///
  ///        (technically if the Auth0 domains are different, both names and domains should
  ///        be ok, because they will have different Auth0 clients and skillseeker endpoints.
  ///        But safer to make globally unique.)
  ///
  ///    (2) Retrieve Auth0Domain and Auth0 Client ID from that call and create client
  ///
  ///    (3) Report back if possible - needs return value from this call
  onCreate = async (item: AppClient, createWithGlobalGroup: boolean): Promise<void> => {
    if (!this.props.store.isSuperUser) {
      throw new Error('cannot create client - not authorized');
    } else {
      const auth0req = makeCreateAuth0ClientReq({
        name: item.name,
        subDomain: item.domainName,
        loginBackground: item.loginBackgroundUrl,
        logoUrl: item.logoUrl
      });

      const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
      try {
        // No auto-refresh
        const auth0Client = await this.props.store.createAuth0Client(auth0req);

        item.auth0Domain = auth0Client.auth0Domain;
        item.auth0ClientId = auth0Client.clientId;

        /// Drop the new client ID here...
        if (createWithGlobalGroup) {
          await this.props.store.createWithGroup(item);
        } else {
          /// TODO: Defer refresh to ensure confirmation dialog pops up OBSOLETE
          await this.props.store.create(item, true);
        }

        toast.dismiss(toastId);
        toast.success(
          `Site ${item.name} created. Auth0 Domain ${auth0Client.auth0Domain} 
          Auth0 Client ID ${auth0Client.clientId}
          Site Hostname ${item.domainName}`,
          { ...toastOptions, onClose: this.props.onCancel, autoClose: 3000 }
        );
      } catch (e) {
        toast.dismiss(toastId);
        toast.error(`Site ${item.name} create failed: ${(e as Error).message}`, {
          ...toastOptions,
          onClose: this.props.onCancel
        });
      }
    }
  };

  validateAuth0Update = (item: WithDbId<AppClient>): UpdateAuth0ClientReq | undefined => {
    const { client: inputItem, store } = this.props;
    /// --- [ FF2-510 Don't call Auth0 if name/sub/logo/background URL unchanged ] ---
    /// OR if not authorized
    if (store.isSuperUser) {
      if (inputItem) {
        let auth0ChangeDetected = false;
        const update: UpdateAuth0ClientReq = makeUpdateAuth0ClientReq({
          appClientId: item.id,
          auth0ClientId: item.value.auth0ClientId,
          name: null,
          subDomain: null,
          loginBackground: null,
          logoUrl: null
        });
        if (inputItem.value.name !== item.value.name) {
          update.name = item.value.name;
          auth0ChangeDetected = true;
        }
        if (inputItem.value.domainName !== item.value.domainName) {
          update.subDomain = item.value.domainName;
          auth0ChangeDetected = true;
        }
        if (
          inputItem.value.loginBackgroundUrl.kind !== item.value.loginBackgroundUrl.kind ||
          (inputItem.value.loginBackgroundUrl.kind === 'url' &&
            item.value.loginBackgroundUrl.kind === 'url' &&
            inputItem.value.loginBackgroundUrl.value !== item.value.loginBackgroundUrl.value)
        ) {
          update.loginBackground = item.value.loginBackgroundUrl;
          auth0ChangeDetected = true;
        }
        if (inputItem.value.logoUrl !== item.value.logoUrl) {
          update.logoUrl = item.value.logoUrl;
          auth0ChangeDetected = true;
        }

        return auth0ChangeDetected ? update : undefined;
      }
    }
    return undefined;
  };

  /// UPDATE
  ///    Change in subdomain *updates* first endpoint in Auth0 client.
  ///
  ///    Auth0 will not allow multiple clients with the same name in the same tenant
  ///    (Auth0 domain), but doesn't enforce subdomain uniqueness. However, skillseeker does.
  ///
  ///    Auth0 domain and Auth0 client ID should be write-once only, which is enforced
  ///    in the editor.
  ///
  ///    This instance is connected to just one tenant (auth0 domain), ie prod->prod, uat->uat.
  ///    To create a different (eg UAT) instance, log into that system.
  ///    (1) Pass updated logoUri, name, subdomain to Auth0
  ///    (2) Report back if possible.
  onUpdate = async (item: WithDbId<AppClient>): Promise<void> => {
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      const auth0req = this.validateAuth0Update(item);
      if (auth0req) {
        await this.props.store.updateAuth0Client(auth0req);
      }

      /// TODO: Defer refresh to ensure confirmation dialog pops up OBSOLETE
      await this.props.store.update(item, true);

      toast.dismiss(toastId);
      toast.success(`Site ${item.value.name} updated.`, {
        ...toastOptions,
        onClose: this.props.onCancel,
        autoClose: 3000
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Site ${item.value.name} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: this.props.onCancel
      });
    }
  };

  // onDeletes = async (a: DbKey<AppClient>[]) => {
  //   try {
  //     await this.props.onDelete(a);
  //     runInAction(() => (this.fieldState.deletedClients = a.slice()));
  //   } catch (e) {
  //     runInAction(() => (this.fieldState.error = e as Error));
  //   }
  // };

  @action
  onCancel = () => {
    this.fieldState = {};
    this.props.onCancel();
  };

  renderContent = () => {
    const {
      client,
      clientData,
      mode,
      repository,
      store
      // toDelete,
    } = this.props;
    if (mode === 'update' && client) {
      return (
        <AppClientEditor
          item={client}
          learningProviders={clientData.learningProviderList.items}
          ssoConnections={clientData.ssoConnectionList.items}
          repository={repository}
          onLoadClientRepository={store.loadClientRepository}
          onUpload={store.uploadRepositoryEntry}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
      /// TODO Delete
    } else {
      return (
        <AppClientEditor
          learningProviders={clientData.learningProviderList.items}
          ssoConnections={clientData.ssoConnectionList.items}
          repository={repository}
          onLoadClientRepository={store.loadClientRepository}
          onUpload={store.uploadRepositoryEntry}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          role={store.isSuperUser ? 'super' : 'client-admin'}
        />
      );
    }
  };

  /** @deprecated Stop using modals */
  renderModal() {
    return (
      <AdminModal
        isOpen={this.props.isOpen}
        onRequestClose={this.onCancel}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        {this.renderContent()}
      </AdminModal>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.props.selectMode === 'modal' ? this.renderModal() : this.renderContent()}
        <ToastContainer newestOnTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/appclient-form/appclient-form.tsx